import { getAnalytics } from '../../common/analytics';
export const smsFormLoaded = phone => {
  const properties = {
    phone,
  };
  getAnalytics().track('SMS Subscription Form Loaded', properties);
};

export const smsSubscriptionCreated = () => {
  getAnalytics().track('SMS Subscription Created', {});
};
